"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmailSentInfo = EmailSentInfo;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@cian/ui-kit");
var _sentEmail = require("../../types/sentEmail");
var _SubtitleLayout = require("../SubtitleLayout");
var styles = _interopRequireWildcard(require("./styles.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function EmailSentInfo(_ref) {
  let {
    viewData
  } = _ref;
  const content = React.useMemo(() => {
    if (viewData.type === _sentEmail.ESentEmailType.Registration) {
      return /*#__PURE__*/React.createElement(_uiKit.ArticleParagraph1, null, "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u043F\u043E\u0447\u0442\u0443\xA0\u2014 \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u043F\u0438\u0441\u044C\u043C\u043E \u043D\u0430\xA0", /*#__PURE__*/React.createElement("span", {
        className: styles['email']
      }, viewData.email));
    } else {
      return /*#__PURE__*/React.createElement(_uiKit.ArticleParagraph1, null, "\u041F\u0438\u0441\u044C\u043C\u043E \u0441\xA0\u0438\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u0435\u0439 \u043F\u043E\xA0\u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044E \u043F\u0430\u0440\u043E\u043B\u044F \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E \u043D\u0430\xA0\u0430\u0434\u0440\u0435\u0441", ' ', /*#__PURE__*/React.createElement("span", {
        className: styles['email']
      }, viewData.email));
    }
  }, [viewData]);
  return /*#__PURE__*/React.createElement(_SubtitleLayout.SubtitleLayout, {
    offset: _SubtitleLayout.ESubtitleOffset.XL
  }, content);
}